<template>
  <div class="sorter__container" @click="onClick" :title="active ? 'Switch sort direction' : `Sort by ${title}`">
    <span class="sorter">
      <span
        :class="`icon icon--arrow-down ${sortDirection === 'asc' ? 'icon--arrow-down--up' : '' }`"
        v-if="active"
      >
        <svg>
          <use xlink:href="#icon--arrow-down"></use>
        </svg>
      </span>
    </span>
    <span>
      <slot/>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    sortBy: {
      type: String,
      required: true
    },
    sortDirection: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    },
    // Should take two args, sortBy and direction
    sort: {
      type: Function,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      ascending: this.sortDirection === 'asc'
    };
  },
  methods: {
    onClick() {
      // If already active, toggle sort direction
      if (this.active) this.ascending = !this.ascending;
      this.sort(this.sortBy, this.ascending ? 'asc' : 'dsc');
    }
  }
};
</script>

<style>
.sorter__container {
  display: flex;
  align-items: center;
}
.sorter {
  position: relative;
  display: inline-block;
  height: 100%;
}
.sorter__arrow {
  display: block;
  cursor: pointer;
  line-height: 0.5;
}
.sorter__arrow--active {
  color: #000;
}
.icon--arrow-down svg {
  transition: transform 300ms ease-in-out;
}
.icon--arrow-down--up svg {
  transform: rotate(180deg);
}
</style>
